import topicMessageHandler from './topicMessageHandler';

/**
 * AI 작업 관련 이벤트 타입 목록
 * 이 배열에 추가하면 자동으로 'ai_job' 타입으로 분류됨
 */
const AI_JOB_EVENT_TYPES = [
  'AI_JOB_STARTED',
  'AI_JOB_COMPLETED',
  'AI_JOB_FAILED',
  'ai_job_started',
  'ai_job_completed',
  'ai_job_failed'
];

// topicPath별 커스텀 핸들러를 저장 
const topicHandlerRegistry = new Map();

/**
 * 메시지 타입 분류
 * payload의 eventType, type, messageType을 확인하여 분류
 * 
 * @param {unknown} payload - 메시지 본문
 * @returns {string} 메시지 타입 ('ai_job' | 'default')
 */
const classifyMessageType = (payload) => {
  if (!payload || typeof payload !== 'object') {
    return 'default';
  }
  
  // eventType, type, messageType 중 하나라도 AI_JOB 관련이면 'ai_job' 타입
  const eventType = payload.eventType || payload.type || payload.messageType;
  
  if (eventType && AI_JOB_EVENT_TYPES.includes(eventType)) {
    return 'ai_job';
  }
  
  // 문자열 포함 여부 확인 (하위 호환성)
  if (eventType && typeof eventType === 'string') {
    const upperEventType = eventType.toUpperCase();
    if (upperEventType.includes('AI_JOB')) {
      return 'ai_job';
    }
  }
  
  return 'default';
};

/**
 * topic으로부터 전달받은 메시지를 분류하고 적절한 핸들러로 전달
 * @param {string} topicPath - 메시지를 수신한 토픽 경로
 * @param {unknown} payload - STOMP 메시지 본문
 */
const dispatchTopicMessage = (topicPath, payload) => {
  // 1. 커스텀 핸들러가 등록되어 있으면 직접 호출
  const customHandler = topicHandlerRegistry.get(topicPath);
  if (customHandler) {
    customHandler(payload, topicPath);
    return;
  }

  // 2. 메시지 타입 분류 (Manager의 책임)
  const messageType = classifyMessageType(payload);

  // 3. 분류된 타입을 Handler에 전달 (Handler는 처리만 담당)
  topicMessageHandler.handleByMessageType(messageType, topicPath, payload);
};

/**
 * 특정 topic 경로에 대한 핸들러 등록
 * @param {string} topicPath - 토픽 경로 (/topic/events/{companySeq})
 * @param {(payload: unknown, topicPath: string) => void} handler - 메시지 처리 함수
 */
const registerTopicHandler = (topicPath, handler) => {
  topicHandlerRegistry.set(topicPath, handler);
};

/**
 * 특정 topic 경로에 대한 핸들러 해제
 * @param {string} topicPath - 토픽 경로
 */
const unregisterTopicHandler = (topicPath) => {
  topicHandlerRegistry.delete(topicPath);
};

const topicMessageManager = {
  dispatchTopicMessage,
  registerTopicHandler,
  unregisterTopicHandler
};

export default topicMessageManager;